import Vue from 'vue'

import Qs from 'qs'

class TicketExpenses {
  async indexTicket({ticketId, params}) {
    return await Vue.axios
      .get('app/ticket-expenses/by-ticket/' + ticketId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async createTicket({ticketId, data}) {
    return await Vue.axios
      .post('app/ticket-expenses/by-ticket/' + ticketId, data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/ticket-expenses/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/ticket-expenses/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/ticket-expenses/' + id)
  }
}

const ticketExpenses = new TicketExpenses()

export default ticketExpenses
